import Scrollbar from 'src/components/scrollbar';
import Label from '../../../components/label/Label';
import {
  DetailColumn,
  DetailContainer,
  DetailRow
} from '../../../layouts/simple/DetailColumnAndRow';
import ListingOrderItemGeneral, { ListingOrderItemStatus } from '../../../models/owner-portal/loi';
import { fCurrency } from '../../../utils/formatNumber';
import { FDateFormat, fDate } from '../../../utils/formatTime';

interface Props {
  loi: ListingOrderItemGeneral;
}

export default function LoiDetails({ loi }: Props) {
  const {
    title,
    name_detailed,
    status,
    type,
    sub_type,
    name,
    last_modified_date_ISO,
    end_date_ISO,
    amount,
    discount,
    total_amount,
    tax_amount,
    description
  } = loi;

  return (
    <Scrollbar className="max-h-[90dvh]">
      <DetailContainer>
        <div>
          <div className="flex w-full flex-row items-center justify-between gap-2">
            <h5 className="text-xl font-semibold whitespace-nowrap">{name}</h5>
            <Label
              variant="soft"
              color={
                (status === ListingOrderItemStatus.approved && 'primary') ||
                (status === ListingOrderItemStatus.close && 'warning') ||
                'info'
              }
              className="w-fit"
            >
              {status}
            </Label>
          </div>
        </div>
        <DetailRow>
          <DetailColumn fullWidth>
            <span className="text-xs uppercase tracking-wider text-muted-foreground pt-0.5">
              Title
            </span>
            <span className="text-base">{title}</span>
          </DetailColumn>
        </DetailRow>
        <DetailRow>
          <DetailColumn fullWidth>
            <span className="text-xs uppercase tracking-wider text-muted-foreground pt-0.5">
              Property
            </span>
            <span className="text-base">{name_detailed}</span>
          </DetailColumn>
        </DetailRow>
        <DetailRow>
          <DetailColumn>
            <span className="text-xs uppercase tracking-wider text-muted-foreground pt-0.5">
              Type
            </span>
            <span className="text-base">{type || '-'}</span>
          </DetailColumn>
          <DetailColumn>
            <span className="text-xs uppercase tracking-wider text-muted-foreground pt-0.5">
              Sub Type
            </span>
            <span className="text-base">{sub_type || 'Other'}</span>
          </DetailColumn>
        </DetailRow>
        {description && (
          <DetailRow>
            <DetailColumn fullWidth>
              <span className="text-xs uppercase tracking-wider text-muted-foreground pt-0.5">
                Description
              </span>
              <span className="text-base">{description}</span>
            </DetailColumn>
          </DetailRow>
        )}
        <DetailRow>
          {!Number.isNaN(amount) && (
            <DetailColumn third>
              {/* Amount */}
              <span className="text-xs uppercase tracking-wider text-muted-foreground pt-0.5">
                Amount
              </span>
              <span className="text-base">{fCurrency(amount, true)}</span>
            </DetailColumn>
          )}
          {!Number.isNaN(discount) && (
            <DetailColumn third>
              {/* discount */}
              <span className="text-xs uppercase tracking-wider text-muted-foreground pt-0.5">
                Discount
              </span>
              <span className="text-base">{fCurrency(discount, true)}</span>
            </DetailColumn>
          )}
          {!Number.isNaN(tax_amount) && (
            <DetailColumn third>
              {/* discount */}
              <span className="text-xs uppercase tracking-wider text-muted-foreground pt-0.5">
                Taxes
              </span>
              <span className="text-base">{fCurrency(tax_amount, true)}</span>
            </DetailColumn>
          )}
        </DetailRow>
        <DetailRow>
          {!Number.isNaN(total_amount) && (
            <DetailColumn fullWidth={!end_date_ISO}>
              <span className="text-xs uppercase tracking-wider text-muted-foreground pt-0.5">
                Total Amount
              </span>
              <span className="text-base">{fCurrency(total_amount, true)}</span>
            </DetailColumn>
          )}
          {end_date_ISO && (
            <DetailColumn>
              <span className="text-xs uppercase tracking-wider text-muted-foreground pt-0.5">
                Close Date
              </span>
              <span className="text-base">
                {fDate(end_date_ISO, FDateFormat.localized_us_numeric_month_day_year)}
              </span>
            </DetailColumn>
          )}
        </DetailRow>
        <DetailRow>
          {/* Updated */}
          <DetailColumn fullWidth>
            <span className="text-sm text-muted-foreground pt-0.5">
              Last updated on {fDate(last_modified_date_ISO, FDateFormat.localized_date_time_full)}
            </span>
          </DetailColumn>
        </DetailRow>
      </DetailContainer>
    </Scrollbar>
  );
}
